










































































































































































































import { computed, defineComponent, ref, Ref, watch, onMounted } from '@vue/composition-api';
import { useClient, useModelstatistics } from '@/use';
import { Models, ModelStatistics } from '@/types';
import DevModelStatisticsMenu from './DevModelStatisticsMenu.vue';
import { devModelStatisticsDialog } from '../state';

const metricsListHeaders = [
  { text: 'FAU', value: 'fau' },
  { text: 'Accuracy', value: 'accuracy', sortable: false },
  { text: 'F1', value: 'f1', sortable: false },
  { text: 'Precision', value: 'precision', sortable: false },
  { text: 'Sensitivity', value: 'sensitivity', sortable: false },
  { text: 'Test Confusion Matrix', value: 'confusion', sortable: false },
];

export default defineComponent({
  name: 'ModelStatisticsMenu',
  components: { DevModelStatisticsMenu },
  setup() {
    const client = useClient();
    const modelOptions: Ref<Models> = ref<Models>({});
    const selectedOptions = ref({
      fau: [''],
      'pain-mgs': [''],
    });
    const subjectTypes = ref<string[]>([]);
    const studyTypes = ref<string[]>(['pain-mgs']);
    const {
      selectedSubject,
      selectedStudyType,
      selectedModel,
      fetch,
      modelStatistics,
      statisticsJson,
    } = useModelstatistics();
    async function getModelOptions() {
      const modelsResponse = await client.getModels();
      subjectTypes.value = Object.keys(modelsResponse).filter((key) => key !== 'rat');
      modelOptions.value = modelsResponse;

      // eslint-disable-next-line dot-notation
      selectedOptions.value = modelOptions.value['general'];
    }
    function updateSelectedModels() {
      selectedModel.value = selectedOptions.value['pain-mgs'].includes('default') ? 'default' : selectedOptions.value['pain-mgs'][0];
    }
    function updateOptions() {
      selectedOptions.value = modelOptions.value[selectedSubject.value];
      updateSelectedModels();
    }
    function showDetail() {
      devModelStatisticsDialog.value = true;
    }
    // Fetch models on creation
    getModelOptions();
    // Watch subject change from video selection or direct change
    watch(selectedSubject, updateOptions);
    onMounted(async () => {
      fetch();
    });
    const metricsPerFau = computed(() => {
      if (!modelStatistics.value) {
        return [];
      }
      return Object.keys(modelStatistics.value).map((fau) => ({
        fau,
        accuracy: Object.keys(modelStatistics.value).includes(fau) ? modelStatistics.value[fau as keyof ModelStatistics].results.accuracy.toFixed(4) : NaN,
        f1: Object.keys(modelStatistics.value).includes(fau) ? modelStatistics.value[fau as keyof ModelStatistics].results.f1?.toFixed(4) : NaN,
        precision: Object.keys(modelStatistics.value).includes(fau) ? modelStatistics.value[fau as keyof ModelStatistics].results.precision?.toFixed(4) : NaN,
        sensitivity: Object.keys(modelStatistics.value).includes(fau) ? modelStatistics.value[fau as keyof ModelStatistics].results.sensitivity?.toFixed(4) : NaN,
        confusion: Object.keys(modelStatistics.value).includes(fau) ? modelStatistics.value[fau as keyof ModelStatistics].test_confusion_matrix : NaN,
      }));
    });
    return {
      subjectTypes,
      studyTypes,
      selectedSubject,
      selectedStudyType,
      selectedOptions,
      selectedModel,
      metricsPerFau,
      metricsListHeaders,
      statisticsJson,
      showDetail,
      devModelStatisticsDialog,
    };
  },
});
